import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Container, Input, useEventCallback } from '@mui/material';

import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { useLocation } from 'react-router-dom';
import { Radio, RadioGroup, FormLabel } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { pink } from '@mui/material/colors';

import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
import ConferenceNavbar from "../../frontend/Conference/ConferenceNavbar";
//import WorkshopFooter from "./WorkhopFooter/WorkshopFooter";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useDeadline } from "../../contexts/DeadlineContext";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useRef } from 'react';
import _isEqual from 'lodash/isEqual';


function createData(
    id,
    coupon_code,
    workshop_id,
    disount,



) {
    return { id, coupon_code, workshop_id, disount, };
}



const rowssss = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, '789', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),



].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

// const coupons = [
//     { id: 1, code: '123', workshop_id: 6 },
//     { id: 2, code: 'kfsRY7IRcI', workshop_id: 6 },
//     { id: 3, code: 'micSSQ4CA', workshop_id: 28 },
//     { id: 4, code: 'fixFDMJIK', workshop_id: 5 },
//     { id: 5, code: '963', workshop_id: 7 },
//     { id: 6, code: '258', workshop_id: 25 },
//     { id: 7, code: '147', workshop_id: 26 },
// ];

// const rows = [
//     createData(1, '123', 6),
//     createData(1, 'kfsRY7IRI'),
//     createData(2, 'micSSQ4CA'),
//     createData(3, 'fixFDMJIK', 5),
//     createData(4, '963', 7),
//     createData(5, '258', 25),
//     createData(6, '147', 26),
// ].map((row, index) => {
//     const coupon = coupons.find((coupon) => coupon.code === row.couponCode);
//     const discount = coupon ? coupon.discount : 0;
//     return { ...row, discount };
// }).sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

//const steps = ['Step 1', 'Step 2', 'Step 3']; // Define your steps
const steps = ['Step 1',]; // Define your steps

const UpdateConfereceParticipant = (props) => {
    const id = props.match.params.id;
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    const gradientBackground = '#05597D';
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const cardStyles = {
        width: isSmallScreen ? '85vw' : isMediumScreen ? '80vw' : '60vw',
        margin: 'auto',
    };
    const [editConferenceParticpant, setEditConferenceParticpant] = React.useState({

        category_amount: "",
        is_active: "",
        name_title: "",
        participant_address: "",
        participant_city: "",
        participant_country: "",
        participant_email: "",
        participant_gender: "",
        participant_name: "",
        participant_phone_number: "",
        particent_profession: "",
        participant_saudi_council_no: "",
        participant_workshop_categoy_id: "",
        password: "",
        error_list: [],
    });

    const [selectedCurrency, setSelectedCurrency] = useState(editConferenceParticpant?.event_affiliate_status ? 'USA' : 'SAR'); // Default to Saudi Riyal
    const currencyOptions = [
        { value: 'SAR', label: 'Saudi Riyal' },
        { value: 'ARE', label: 'UAE Dirham' },
        { value: 'USA', label: 'US Dollar' },
    ];

    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        // Initialize form data here
        firstName: '',
        lastName: '',
        email: '',
    });
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid');
    const [nameTitle, setNameTitle] = useState('');
    const [gender, setGender] = useState(''); // state to hold the selected value
    const [country, setCountry] = useState('');
    const [registrationType, setRegistrationType] = useState('');
    const [assignModule, setassignModules] = useState([]);
    const [checkmodules, setCheckedmodules] = useState([]);
    const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
    const [singleConferenceCategory, setSingleConferenceCategory] = useState('');
    const [selectedConferences, setSelectedWorkshops] = useState([]);
    const [selectedConferenceAmounts, setSelectedConferenceAmounts] = useState([]);
    const [discountMessages, setDiscountMessages] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [disabledInputs, setDisabledInputs] = useState({});
    const [showCouponInputs, setShowCouponInputs] = useState({});
    const [conferenceUsedCoupeon, setConferenceUsedCoupeon] = useState([]);
    const tableCellRef = useRef(null);
    const [isCopied, setIsCopied] = useState(false);
    const [copiedStates, setCopiedStates] = useState({});
    const [conferenceTotalSeatCount, setConferenceTotalSeatCount] = useState();
    const conference_particpant_email = localStorage.getItem('conference_particpant_email');

    // const [abstractHomeSetup, setAbstractHomeSetup] = useState({
    //     color_code: "",
    //     color_code_two: "",
    //     color_code_three: "",
    //     call_emergency: "",
    //     send_email: "",
    //     event_place: "",
    //     facebook_link: "",
    //     Instagram_link: "",
    //     linkedin_link: "",
    //     twitter_link: "",
    //     abstractFooterImage: "",
    //     abstractBannerImage: "",
    //     workshopBannerImage: "",
    //     abstractSponserLogos: "",
    //     event_name: "",
    //     online_status: "",
    //     bank_status: "",
    //     cash_status: "",
    //     free_status: "",
    //     error_list: [],
    // });
    // React.useEffect(() => {
    //     axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
    //         if (res.status === 200) {
    //             const getHomePageData = res.data.HomePageSetup;
    //             setAbstractHomeSetup(getHomePageData);
    //         }
    //     })

    // }, [eventid]);
    const [addWorkShopParticpant, setAddConferenceParticpant] = React.useState({
        workShop_partecpant_name: "",
        instituteWorkPlace: "",
        city: "",
        phone: "",
        particent_email: "",
        saudiCouncilno: "",
        price: "",
        profession: "",
        // password: "",
        // phone: "",
        // date: "",
        // address: "",
        // details: "",
        error_list: [],
    });

    const [editConferenceParticpantConferences, setEditConferenceParticpantConferences] = React.useState({
        categoy_id: "",
        conference_amount: "",
        conference_code: "",
        conference_discount: "",
        conference_id: "",
        conference_name: "",
        conference_participant_id: "",
        conference_type: "",
        conference_coupon: "",
        conference_url: "",
        conference_start_time: "",
        conference_date: "",
        payment_status: "",


    });
    const [updateConferenceParticpantConferences, setupdateConferenceParticpantConferences] = React.useState({

        // categoy_id: "",
        // workshop_amount: "",
        // workshop_code: "",
        // workshop_discount: "",
        // workshop_id: "",
        // workshop_name: "",
        // workshop_participant_id: "",
        // workshop_type: "",
        // workshop_coupon: "",
        // workshop_url: "",
        // workshop_start_time: "",
        // workshop_date: "",
        // payment_status: "",

    });





    useEffect(() => {
        const fetchParticipantData = async () => {
            try {
                const res = await axios.get(`api/conference-participant-edit/${id}`);
                if (res.status === 200) {
                    const { participant, conferences, payment } = res.data.data;
                    const selectedRegistrationType = participant.conference_category_id;

                    setEditConferenceParticpant(participant);
                    setNameTitle(participant.name_title);
                    setGender(participant.participant_gender);
                    setCountry(participant.participant_country);

                    const conferenceData = conferences.map(conference => {
                        const confDetails = conference.conference;

                        return {
                            categoy_id: confDetails.conference_category_id,
                            conference_id: confDetails.id,
                            conference_amount: confDetails.conference_amount,
                            conference_coupon: confDetails.conference_coupon,
                            conference_day: confDetails.conference_day,
                            conference_name: confDetails.conference_name,
                            conference_discount_amount: confDetails.conference_discount_amount,
                            payment_status: conference.payment_status ? 1 : 0
                        };
                    });

                    setEditConferenceParticpantConferences(conferenceData);
                    setupdateConferenceParticpantConferences(conferenceData);




                    const response = await axios.get(`api/conference-category-front-single/${selectedRegistrationType}`);
                    //console.log(response.data.totalSeatCount)

                    if (response.status === 200) {
                        setSingleConferenceCategory(response.data.swsd);
                        // const totalSeatCounts = conferences.map(conference => conference.conference_no_ofseats);
                        //setConferenceTotalSeatCount(response.data.totalSeatCount);
                        setConferenceTotalSeatCount(response.data.totalSeatCount);
                        setEditConferenceParticpant(prevState => ({
                            ...prevState,
                            conference_category_id: selectedRegistrationType,
                        }));
                    } else {
                        swal('Error', 'Check API Something Wrong', 'error');
                    }
                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            } catch (error) {
                console.error('Error fetching participant data:', error);
                swal('Error', 'Failed to fetch participant data', 'error');
            }
        };

        fetchParticipantData();
    }, [id]);




    useEffect(() => {
        axios.get(`api/conference-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const ccategoryData = res.data.conferenceCategories;
                setConferenceCategoryData(ccategoryData);


            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    useEffect(() => {
        axios.get(`api/conference-participant-used-coupeons?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const usedCoupen = res.data.usedCoupons;

                setConferenceUsedCoupeon(usedCoupen);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
    const [colorMap, setColorMap] = useState({});



    const handleCheckboxChange = (event, workshop, final_conference_price,) => {

        // Check if the workshop object is valid
        if (!workshop || typeof workshop !== 'object') {
            console.error('Invalid workshop object:', workshop);
            return;
        }
        console.log("final_conference_price", final_conference_price);
        let conference_amount = final_conference_price;

        if (editConferenceParticpant?.event_affiliate_status === 1 && workshop?.conference_discount_amount) {
            conference_amount = workshop.conference_discount_amount;
        }
        // Extract necessary fields from the workshop object
        const {
            id,

            conference_category_id,
            conference_coupon,
            conference_date,
            conference_day,
            conference_discount_amount,
            conference_end_time,
            conference_name,
            conference_no_ofseats,
            conference_start_time,
            conferencecategory,
            created_at,
            created_by,
            event_id,
            event_name,
            status,
            updated_at
        } = workshop;

        // Check if the workshop is already selected
        const isAlreadySelected = editConferenceParticpantConferences.some(
            (selectedConference) => selectedConference.conference_id === id
        );

        // Handle the checkbox change
        if (event.target.checked && !isAlreadySelected) {
            // Generate a unique color for the row based on specific fields
            const uniqueColor = getColorForFields(conference_date, conference_start_time);

            // Update the state with the new workshop
            setEditConferenceParticpantConferences((prevConferences) => [
                ...prevConferences,
                {
                    conference_id: id,
                    conference_amount,
                    conference_category_id,
                    conference_coupon,
                    conference_date,
                    conference_day,
                    conference_discount_amount,
                    conference_end_time,
                    conference_name,
                    conference_no_ofseats,
                    conference_start_time,
                    conferencecategory,
                    created_at,
                    created_by,
                    event_id,
                    event_name,
                    status,
                    updated_at,
                    isDisabled: false, // Enable the current workshop checkbox
                },
            ]);

            // Add the workshop amount to the selected workshop amounts
            setSelectedConferenceAmounts((prevAmounts) => [
                ...prevAmounts,
                {
                    id,
                    conference_amount,
                    conference_coupon,
                    conference_date,
                    conference_day,
                    conference_discount_amount,
                    conference_end_time,
                    conference_name,
                    conference_no_ofseats,
                    conference_start_time,
                    conferencecategory,
                    created_at,
                    created_by,
                    event_id,
                    event_name,
                    status,
                    updated_at,
                },
            ]);

            // Update the color map with the unique color for the specific row values
            setColorMap((prevColorMap) => ({
                ...prevColorMap,
                [`${conference_day}-${conference_date}-${conference_start_time}`]: uniqueColor,
            }));
        } else if (!event.target.checked && isAlreadySelected) {
            // Remove the workshop from the list of selected workshops
            setEditConferenceParticpantConferences((prevConferences) =>
                prevConferences.filter((selectedConference) => selectedConference.conference_id !== id)
            );

            // Remove the workshop amount from the selected workshop amounts
            setSelectedConferenceAmounts((prevAmounts) =>
                prevAmounts.filter((item) => item.id !== id)
            );

            // Clear the color map entry when the row is unchecked
            // setColorMap((prevColorMap) => {
            //     const newColorMap = { ...prevColorMap };
            //     delete newColorMap[`${conference_date}-${conference_start_time}`];
            //     return newColorMap;
            // });
            setColorMap((prevColorMap) => {
                const newColorMap = { ...prevColorMap };
                delete newColorMap[`${conference_day}-${conference_date}-${conference_start_time}`]; // Updated to match the key
                return newColorMap;
            });
        }
    };




    const handleCurrencyChange = (event) => {
        const newCurrency = event.target.value;
        setSelectedCurrency(newCurrency);

        // Clear all selections when currency changes
        setEditConferenceParticpantConferences([]);
        setSelectedConferenceAmounts([]);
        // setColorMap({});


    };
    const getPriceByCurrency = (conference, currency) => {
        switch (currency) {
            case 'SAR':
                return conference.conference_amount;
            case 'ARE':
                return conference.conference_aed_price;
            case 'USA':
                return conference.conference_doller_price;
            default:
                return conference.conference_amount;
        }
    };



    useEffect(() => {
        if (!Array.isArray(editConferenceParticpantConferences) || editConferenceParticpantConferences.length === 0) return;

        const hasUnpaidConferences = editConferenceParticpantConferences.some(
            conference => conference.payment_status !== 1
        );

        if (hasUnpaidConferences) {
            const updatedAmounts = editConferenceParticpantConferences
                .filter(conference => conference.payment_status !== 1)
                .map(conf => {
                    // Handle discount logic based on event_affiliate_status
                    const isAffiliate = editConferenceParticpant?.event_affiliate_status === 1;
                    const conference_amount = isAffiliate
                        ? parseFloat(conf.conference_discount_amount || 0)
                        : parseFloat(conf.conference_amount || 0);

                    return {
                        id: conf.conference_id,
                        conference_day: conf.conference_day,
                        conference_amount,
                        conference_name: conf.conference_name,
                        conference_coupon: conf.conference_coupon,
                    };
                });

            setSelectedConferenceAmounts(updatedAmounts);
        } else {
            setSelectedConferenceAmounts([]);
        }
    }, [editConferenceParticpantConferences, editConferenceParticpant]);




    // useEffect(() => {
    //     if (!Array.isArray(editConferenceParticpantConferences)) return;

    //     // Check if there are any workshops with payment_status === 1
    //     const hasUnpaidConferences = editConferenceParticpantConferences.some(
    //         conference => conference.payment_status !== 1
    //     );

    //     // If there are unpaid workshops, update selectedConferenceAmounts
    //     if (hasUnpaidConferences) {
    //         setSelectedConferenceAmounts(
    //             editConferenceParticpantConferences
    //                 .filter(conference => conference.payment_status !== 1)
    //                 .map(({ conference_id, conference_day, conference_amount, conference_name, conference_coupon }) => ({
    //                     id: conference_id,
    //                     conference_day,
    //                     conference_amount,
    //                     conference_name,
    //                     conference_coupon,
    //                 }))
    //         );
    //     } else {
    //         // If there are no unpaid workshops, clear selectedConferenceAmounts
    //         setSelectedConferenceAmounts([]);
    //     }


    // }, [editConferenceParticpantConferences]);



    const handleregistration = (e) => {
        const selectedRegistrationType = e.target.value;

        // Trigger API request with the selectedRegistrationType
        axios.get(`api/conference-category-front-single/${selectedRegistrationType}`)
            .then((res) => {
                if (res.status === 200) {
                    const singleConferenceData = res.data.swsd;
                    setSingleConferenceCategory(singleConferenceData);


                    // Update the state with the selected registration type
                    setEditConferenceParticpant(prevState => ({
                        ...prevState,
                        conference_category_id: selectedRegistrationType,
                    }));
                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            })
            .catch((error) => {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching data from the API', 'error');
            });
    };

    const [inputValues, setInputValues] = useState({}); // Use an object to store coupon codes for each workshop
    const handleCouponCodeChange = (conferenceId, enteredCode) => {
        //console.log(`Updating coupon code for workshop ${workshopId} to ${enteredCode}`);
        setInputValues({ ...inputValues, [conferenceId]: enteredCode });
    };

    //const couponCode = '123'; // Assuming coupon code is a string
    const [couponCodes, setCouponCodes] = useState({});

    useEffect(() => {
        axios.get(`api/conference-manage-coupon-index-front?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.conferenceCouponFront;
                setCouponCodes(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);


    const copyCoupon = (couponCode) => {
        navigator.clipboard
            .writeText(couponCode)
            .then(() => {
                setCopiedStates(prevState => ({ ...prevState, [couponCode]: true }));
                setTimeout(() => {
                    setCopiedStates(prevState => ({ ...prevState, [couponCode]: false }));
                }, 3000);
            })
            .catch((err) => {
                console.log(err.message);
            });
    };



    const isCheckboxDisabled = (conference) => {
        const {
            id,
            conference_day,
            conference_date,
            conference_end_date,
            conference_start_time,
            conference_end_time,
            conference_no_ofseats
        } = conference;

        const isDisabledz = editConferenceParticpantConferences.some(
            (selectedConference) =>
                selectedConference.conference_day === conference_day &&
                selectedConference.conference_date === conference_date &&
                selectedConference.conference_start_time === conference_start_time &&
                selectedConference.conference_end_time === conference_end_time &&
                selectedConference.conference_id === id
        );


        // const conferenceDateTime = new Date(`${conference_date}T${conference_start_time}`).getTime();
        // const currentDateTime = new Date().getTime();
        // const isTimePassed = conferenceDateTime < currentDateTime;

        const conferenceDateTime = new Date(`${conference_end_date}T${conference_start_time}`).getTime();
        const currentDateTime = new Date().getTime();
        const isTimePassed = conferenceDateTime < currentDateTime;


        let timeOffMessage = "";
        if (isTimePassed) {
            timeOffMessage = `Expired`
        }

        const countConferences = Array.isArray(conferenceTotalSeatCount)
            ? conferenceTotalSeatCount.filter((conference) => conference?.conference_id === id).length
            : 0;
        const isSeatLimitReached = countConferences >= conference_no_ofseats;
        //console.log("countConferences" ,countConferences)
        let seatLimitMessage = '';
        if (isSeatLimitReached) {
            seatLimitMessage = `All (${countConferences}) seats are full, please uncheck and proceed.`;
        }

        const color = colorMap[`${conference_day}-${conference_date}-${conference_start_time}`];

        // **Change 1**: The condition `!isDisabledz` ensures that if the workshop is already selected, 
        // it won't be disabled purely due to the seat limit or time passed, allowing the checkbox to be unchecked.
        const isDisabled = isTimePassed || (isSeatLimitReached && !isDisabledz);

        return { isDisabled, color, seatLimitMessage, timeOffMessage };
    };




    // Function to generate a unique color based on specific fields
    const getColorForFields = (conference_day, date, startTime) => {
        //return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        if (abstractHomeSetup && abstractHomeSetup.color_code) {
            return abstractHomeSetup.color_code;
        }
        // Fallback to a random color if abstractHomeSetup.color_code is empty or undefined
        return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    };

    useEffect(() => {

        Object.keys(discountMessages).forEach(conferenceId => {
            const message = discountMessages[conferenceId];

        });
    }, [discountMessages]);

    useEffect(() => {

    }, [totalAmount]);

    const [usedCouponMessage, setUsedCouponMessage] = useState([]);
    useEffect(() => {
        Object.keys(usedCouponMessage).forEach(conferenceId => {
            const message = usedCouponMessage[conferenceId];

        });
    }, [usedCouponMessage]);
    const [fullDiscountApplied, setFullDiscountApplied] = useState(false);
    // const fullDiscountApplied = false; // Use a ref to track if the full discount has been applied
    useEffect(() => {
        const newTotalAmount = selectedConferenceAmounts.reduce((acc, conference) => {
            let discount = 0;
            const singleConferenceAmount = Number(conference.conference_amount);

            let matchingCoupon = null;

            if (Array.isArray(couponCodes)) {

                matchingCoupon = couponCodes.find(couponValue => inputValues[conference.id] === couponValue.coupon_code);

            }


            const useCoupon = conferenceUsedCoupeon.filter(couponsVal => inputValues[conference.id] === couponsVal.coupon_code);
            const useCouponCheck = conferenceUsedCoupeon.find(couponsVal => inputValues[conference.id] === couponsVal.coupon_code);
            if (matchingCoupon) {
                if (matchingCoupon.coupon_amout_type === "percentage" && conference.id === matchingCoupon.conference_id
                    &&
                    inputValues[conference.id] === matchingCoupon.coupon_code) {

                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.participant_id;

                        if (particpent_id == getPArticipentId) {

                            const currentDate = new Date();

                            const currentYear = currentDate.getFullYear();
                            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                            const currentDay = String(currentDate.getDate()).padStart(2, '0');
                            const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                            const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                            if (isTimePassedExpired) {
                                const messageUsedCoupon = 'The Coupon is Expired';
                                setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                            }
                            else {
                                discount = (singleConferenceAmount * matchingCoupon.coupon_amout_value) / 100;
                                const fullDiscountApplied = true;
                            }

                        }
                        else if (useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                        }
                    }
                    else {

                        const currentDate = new Date();

                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                        const currentDay = String(currentDate.getDate()).padStart(2, '0');
                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = (singleConferenceAmount * matchingCoupon.coupon_amout_value) / 100;

                            if (parseFloat(matchingCoupon.coupon_amout_value) === 100) {
                                setFullDiscountApplied(true); // ✅ No error now
                            }
                            console.log("fullDiscountApplied", fullDiscountApplied);
                            console.log("discount", discount);
                            console.log("matchingCoupon.coupon_amout_value", matchingCoupon.coupon_amout_value);
                            console.log("singleConferenceAmount", singleConferenceAmount);

                            //console.log("matchingCoupon.coupon_amout_value", matchingCoupon.coupon_amout_value);
                        }


                    }
                }
                else if (matchingCoupon.coupon_amout_type === "fixed" && conference.id === matchingCoupon.conference_id
                    &&
                    inputValues[conference.id] === matchingCoupon.coupon_code) {
                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.participant_id
                        if (particpent_id == getPArticipentId) {

                            const currentDate = new Date();

                            const currentYear = currentDate.getFullYear();
                            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                            const currentDay = String(currentDate.getDate()).padStart(2, '0');
                            const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                            const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                            if (isTimePassedExpired) {
                                const messageUsedCoupon = 'The Coupon is Expired';
                                setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                            }
                            else {
                                const currentDate = new Date();


                                const currentYear = currentDate.getFullYear();
                                const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                                const currentDay = String(currentDate.getDate()).padStart(2, '0');
                                const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                                const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                                if (isTimePassedExpired) {
                                    const messageUsedCoupon = 'The Coupon is Expired';
                                    setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                                }
                                else {
                                    discount = matchingCoupon.coupon_amout_value;
                                    if (parseFloat(matchingCoupon.coupon_amout_value) === 100) {
                                        setFullDiscountApplied(true); // ✅ No error now
                                    }
                                }

                            }

                        }
                        else if (useCoupon && useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));

                        }
                    }
                    else {
                        const currentDate = new Date();
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
                        const currentDay = String(currentDate.getDate()).padStart(2, '0');
                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [conference.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = matchingCoupon.coupon_amout_value;

                        }
                    }
                }


                if (!isNaN(singleConferenceAmount) && discount > 0) {

                    const message = `Discount applied for conference ${conference.id}. Coupon Code: ${inputValues[conference.id]}`;
                    setDiscountMessages(prevMessages => ({ ...prevMessages, [conference.id]: message }));
                    setDisabledInputs(prevDisabled => ({ ...prevDisabled, [conference.id]: true }));

                }
            }

            return acc + (singleConferenceAmount - discount);
        }, 0);

        setTotalAmount(newTotalAmount);
    }, [selectedConferenceAmounts, couponCodes, inputValues]);





    const toggleCouponInput = (conferenceId) => {
        setShowCouponInputs((prevState) => ({
            ...prevState,
            [conferenceId]: !prevState[conferenceId],
        }));
    };

    const handleInput = (e) => {
        const value = e.target.value;
        const inputName = e.target.name;
        setEditConferenceParticpant({ ...editConferenceParticpant, [e.target.name]: e.target.value });


    }

    const handleCountry = (e) => {
        const selectCountry = e.target.value;
        setCountry(selectCountry);
        localStorage.setItem('selectedCountry', selectCountry);
    }

    // const handleChange = (event) => {

    //     setGender(event.target.value);
    //     localStorage.setItem(event.target.value);
    // };
    const handleChange = (event) => {
        setGender(event.target.value);

    };

    // Function to handle radio button change


    const handleNameTitle = (e) => {
        const selectNametitle = e.target.value;

        setNameTitle(selectNametitle);
        localStorage.setItem('nameTitle', selectNametitle)
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleInputChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };




    // const { error_list } = addWorkShopParticpant;
    // const handleSubmitBank = (e) => {
    //     e.preventDefault();
    //     setLoading(true); // Set loading state to true when button is clicked
    //     const paymentBank = "paymentBank";
    //     const data = {
    //         partiticipant_id: id,
    //         eventid,
    //         name_title: nameTitle,
    //         participant_saudi_council_no: editConferenceParticpant.participant_saudi_council_no,
    //         participant_name: editConferenceParticpant.participant_name,
    //         participant_email: editConferenceParticpant.participant_email,
    //         participant_conference_category: singleConferenceCategory.id,
    //         participant_contact: editConferenceParticpant.participant_phone_number,
    //         participant_profession: editConferenceParticpant.participant_profession,
    //         participant_gender: gender,
    //         participant_country: country,
    //         participant_city: editConferenceParticpant.participant_city,
    //         selectedWorkshopAmounts: selectedConferenceAmounts,
    //         participant_cooupons: inputValues,
    //         totalAmount,
    //         paymentBank,


    //         //editConferenceParticpantConferences


    //     };



    //     axios.get('/sanctum/csrf-cookie').then(response => {
    //         const config = {
    //             headers: { 'content-type': 'multipart/form-data' }
    //         }
    //         axios.post(`/api/conference-particpant-update/${id}`, data, config).then(res => {
    //             setLoading(false);
    //             if (res.data.status === 200) {


    //                 swal('Success', res.data.message, 'success');

    //                 // history.push('/workshop/particpant-form/thank-you');
    //                 history.push(`/conference/thank-you/${id}`);
    //                 return false;
    //             }
    //             else {

    //                 setAddConferenceParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

    //             }

    //         }).catch(error => {
    //             setLoading(false); // Set loading state back to false in case of error
    //             console.error('Error:', error);
    //         });
    //     }).catch(error => {
    //         setLoading(false); // Set loading state back to false in case of error
    //         console.error('Error:', error);
    //     });
    // };
    const { error_list } = addWorkShopParticpant;

    const handleSubmitBank = (e) => {
        e.preventDefault();
        setLoading(true); // Start loading

        const paymentBank = "paymentBank";
        const data = {
            participant_id: id, // ✅ fixed typo (was partiticipant_id)
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editConferenceParticpant.participant_saudi_council_no,
            participant_name: editConferenceParticpant.participant_name,
            participant_email: editConferenceParticpant.participant_email,
            participant_conference_category: singleConferenceCategory.id,
            participant_contact: editConferenceParticpant.participant_phone_number,
            participant_profession: editConferenceParticpant.participant_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editConferenceParticpant.participant_city,
            selectedWorkshopAmounts: selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentBank,
        };

        axios.get('/sanctum/csrf-cookie').then(() => {
            const config = {
                headers: { 'Content-Type': 'application/json' }
            };

            axios.post(`/api/conference-particpant-update/${id}`, data, config)
                .then(res => {
                    setLoading(false);

                    if (res.data.status === 200) {
                        swal('Success', res.data.message, 'success');
                        history.push(`/conference/thank-you/${id}`);
                    } else {
                        setLoading(false);
                        // If backend sends custom validation errors
                        setAddConferenceParticpant(prev => ({
                            ...prev,
                            error_list: res.data.validate_error || {}
                        }));
                    }
                })
                .catch(error => {
                    setLoading(false);

                    if (error.response && error.response.status === 422) {
                        // Laravel validation error
                        setAddConferenceParticpant(prev => ({
                            ...prev,
                            error_list: error.response.data.errors
                        }));
                    } else {
                        console.error('Error:', error);
                    }
                });
        }).catch(error => {
            setLoading(false);
            console.error('Error:', error);
        });
    };

    const handleSubmitCash = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked
        const paymentCash = "paymentCash";
        const data = {
            partiticipant_id: id,
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editConferenceParticpant.participant_saudi_council_no,
            participant_name: editConferenceParticpant.participant_name,
            participant_email: editConferenceParticpant.participant_email,
            participant_conference_category: singleConferenceCategory.id,
            participant_contact: editConferenceParticpant.participant_phone_number,
            participant_profession: editConferenceParticpant.participant_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editConferenceParticpant.participant_city,
            selectedWorkshopAmounts: selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentCash,

        };


        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/conference-particpant-update/${id}`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');
                    history.push(`/conference/thank-you/${id}`);
                    return false;
                }
                else {
                    setLoading(false);
                    setAddConferenceParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };

    const handleSubmitOnline = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked

        const paymentOnline = "paymentOnline";
        const data = {
            partiticipant_id: id,
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editConferenceParticpant.participant_saudi_council_no,
            participant_name: editConferenceParticpant.participant_name,
            participant_email: editConferenceParticpant.participant_email,
            participant_conference_category: singleConferenceCategory.id,
            participant_contact: editConferenceParticpant.participant_phone_number,
            participant_profession: editConferenceParticpant.participant_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editConferenceParticpant.participant_city,
            selectedConferenceAmounts: selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentOnline,
            currencyIsPay: selectedCurrency,
        };

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/onlinepayment-conference-particpant-update/${id}`, data, config).then(res => {
                setLoading(false); // Set loading state back to false after operation completes
                if (res.data.status === 200) {
                    const participantId = res.data.participantId;
                    swal('Success', res.data.message, 'success');
                    window.location.href = res.data.redirect.redirect_url;
                } else {
                     setLoading(false);
                    setAddConferenceParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error });
                }
            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };



    const handleSubmitFree = async (e) => {
        e.preventDefault();
        setLoading(true);

        const paymentFree = "paymentFree";
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editConferenceParticpant.participant_saudi_council_no,
            participant_name: editConferenceParticpant.participant_name,
            participant_email: editConferenceParticpant.participant_email,
            participant_conference_category: singleConferenceCategory.id,
            participant_contact: editConferenceParticpant.participant_phone_number,
            participant_profession: editConferenceParticpant.participant_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editConferenceParticpant.participant_city,
            selectedWorkshopAmounts: selectedConferenceAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentFree,
        };

        //     {
        //     data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
        //         data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
        //             data.participant_email == "" ? setLoading(false) : data.participant_workshop_categoy == "" ? setLoading(false) :
        //                 data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
        //                     data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
        //                         data.selectedWorkshopAmounts == "" ? setLoading(false) :
        //                             data.totalAmount == "" ? setLoading(false) : data.paymentBank == "" ? setLoading(false) : setLoading(true)
        // }

        // **Validation: Check for empty values**
        for (const key in data) {
            if (data[key] === "" || data[key] === undefined) {
                setLoading(false);
                swal("Error", `Please fill in the ${key.replace(/_/g, " ")}`, "error");
                return;
            }
        }

        try {
            const config = { headers: { "Content-Type": "multipart/form-data" } };
            const apiUrl = totalAmount === 0
                ? `/api/conference-basic-information-participant-update/${id}`
                : `/api/conference-particpant-update/${id}`;

            const response = await axios.post(apiUrl, data, config);

            if (response.data.status === 200) {
                const participantId = response.data.participantId;
                swal("Success", response.data.message, "success");
                history.push(`/conference/thank-you/${id}`);
            } else {
                setAddConferenceParticpant(prevState => ({
                    ...prevState,
                    error_list: response.data.validate_error
                }));
            }
        } catch (error) {
            swal("Error", "Something went wrong. Please try again later.", "error");
            console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
        }
    };





    const isMobile = useMediaQuery('(max-width:600px)');

    //Check Out
    const renderSelectedWorkshopInfo = () => {


        const handleRemoveWorkshop = (conferenceIdToRemove) => {
            // alert(conferenceIdToRemove)

            // Filter out the workshop to remove from the state
            const updatedWorkshops = selectedConferenceAmounts.filter(conference => conference.id !== conferenceIdToRemove);
            // Update the state with the filtered array
            //console.log(updatedWorkshops)
            setSelectedConferenceAmounts(updatedWorkshops);
        };
        return (
            <div>


                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>

                            {isMobile ? (
                                <TableCell colSpan={5} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Conference Details
                                </TableCell>
                            ) : (
                                <>
                                    <TableCell>Conference Name</TableCell>
                                    <TableCell>Conference Day</TableCell>
                                    <TableCell>Used Coupons</TableCell>
                                    <TableCell align="center">Coupon Input</TableCell>
                                    <TableCell align="right">Conference Amount  ({selectedCurrency})</TableCell>
                                    <TableCell align="right">Action</TableCell>
                                </>
                            )}
                        </TableHead>

                        <TableBody>
                            {selectedConferenceAmounts && selectedConferenceAmounts.map((selectedConference, index) => {
                                const participant_id = id;
                                const workshopId = selectedConference.id;

                                const hasCoupon = conferenceUsedCoupeon.some(
                                    (couponsVal) => Number(selectedConference.id) === Number(couponsVal.conference_id)
                                );

                                const foundCoupon = conferenceUsedCoupeon.find(
                                    (couponsVal) =>
                                        Number(participant_id) === Number(couponsVal.participant_id) &&
                                        Number(selectedConference.id) === Number(couponsVal.conference_id)
                                );

                                const couponCode = hasCoupon ? (foundCoupon ? foundCoupon.coupon_code : '') : '';

                                return (
                                    <>
                                        {isMobile ? (
                                            <TableCell style={{ display: 'flex', flexWrap: 'wrap', flexBasis: '100%' }} key={selectedConference.id}>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>No: {index + 1}</strong>
                                                    <hr />
                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Conference Name: </strong>{selectedConference.conference_name}
                                                    <hr />
                                                </Box>


                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Conference Day: </strong>{selectedConference.conference_day}
                                                    <hr />
                                                </Box>

                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Coupon: </strong>
                                                    {couponCode ? (
                                                        <>
                                                            <span>{couponCode}</span>
                                                            <span
                                                                onClick={() => copyCoupon(couponCode)}
                                                                style={{ cursor: 'pointer', color: '#007bff', marginLeft: '10px' }}
                                                            >
                                                                📋 Copy
                                                            </span>
                                                            {copiedStates[couponCode] && (
                                                                <span style={{ marginLeft: '10px', color: 'green', fontWeight: 'bold' }}>Copied!</span>
                                                            )}
                                                        </>
                                                    ) : 'No Coupon'}
                                                    <hr />
                                                </Box>

                                                {selectedConference.conference_coupon === 1 && (
                                                    <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                        <strong>Coupon Input: </strong>
                                                        <Checkbox
                                                            checked={!!showCouponInputs[selectedConference.id]}
                                                            onChange={() => toggleCouponInput(selectedConference.id)}
                                                        />
                                                        {showCouponInputs[selectedConference.id] && (
                                                            <div style={{ marginTop: '10px' }}>
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Enter Coupon Code"
                                                                    value={inputValues[selectedConference.id] || ''}
                                                                    onChange={(e) => handleCouponCodeChange(selectedConference.id, e.target.value)}
                                                                />
                                                                {discountMessages[selectedConference.id] && (
                                                                    <div style={{ color: 'green', fontWeight: 'bold', marginTop: '5px' }}>
                                                                        Coupon Applied
                                                                    </div>
                                                                )}
                                                                {!discountMessages[selectedConference.id] && usedCouponMessage[selectedConference.id] && (
                                                                    <div style={{ color: 'red', fontWeight: 'bold', marginTop: '5px' }}>
                                                                        {usedCouponMessage[selectedConference.id]}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </Box>
                                                )}

                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Conference Amount  ({selectedCurrency}): </strong>{selectedConference.conference_amount}
                                                    <hr />
                                                </Box>

                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleRemoveWorkshop(selectedConference.id)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </Box>
                                            </TableCell>
                                        ) : (
                                            <TableRow key={selectedConference.id}>
                                                {/* Conference Category */}
                                                <TableCell>{selectedConference.conference_name}</TableCell>
                                                <TableCell>{selectedConference.conference_day}</TableCell>

                                                {/* Used Coupons */}
                                                {couponCode ? (
                                                    <TableCell onClick={() => copyCoupon(couponCode)} style={{ cursor: 'pointer' }}>
                                                        {couponCode}
                                                        <span role="img" aria-label="copy" style={{ fontSize: '1rem', color: '#007bff', marginLeft: '10px' }}>
                                                            📋
                                                        </span>
                                                        {copiedStates[couponCode] && (
                                                            <span style={{ marginLeft: '10px', color: 'green', fontWeight: 'bold' }}>Copied!</span>
                                                        )}
                                                    </TableCell>
                                                ) : (
                                                    <TableCell>No Coupon</TableCell>
                                                )}

                                                {/* Coupon Input */}
                                                <TableCell align="center">
                                                    {selectedConference.conference_coupon === 1 && (
                                                        <>
                                                            <Checkbox
                                                                checked={!!showCouponInputs[selectedConference.id]}
                                                                onChange={() => toggleCouponInput(selectedConference.id)}
                                                            />
                                                            {showCouponInputs[selectedConference.id] && (
                                                                <div style={{ marginTop: '10px' }}>
                                                                    <Input
                                                                        type="text"
                                                                        placeholder="Enter Coupon Code"
                                                                        value={inputValues[selectedConference.id] || ''}
                                                                        onChange={(e) => handleCouponCodeChange(selectedConference.id, e.target.value)}
                                                                    />
                                                                    {discountMessages[selectedConference.id] && (
                                                                        <div style={{ color: 'green', fontWeight: 'bold', marginTop: '5px' }}>
                                                                            Coupon Applied
                                                                        </div>
                                                                    )}
                                                                    {!discountMessages[selectedConference.id] && usedCouponMessage[selectedConference.id] && (
                                                                        <div style={{ color: 'red', fontWeight: 'bold', marginTop: '5px' }}>
                                                                            {usedCouponMessage[selectedConference.id]}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </TableCell>

                                                {/* Conference Amount */}
                                                <TableCell align="right">{selectedConference.conference_amount}</TableCell>

                                                {/* Action */}
                                                <TableCell align="right">
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleRemoveWorkshop(selectedConference.id)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </>
                                );

                            })}


                            <TableRow>
                                <TableCell colSpan={5} align="right" style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                                    Total Amount: {totalAmount}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>


                </TableContainer>
                <Box noValidate sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    {selectedCurrency === 'USA' ? (
                        <>
                            {totalAmount > 0 && abstractHomeSetup.c_online_status == 1 && (
                                <Button
                                    onClick={handleSubmitOnline}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        ml: 4,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                        cursor: loading ? 'not-allowed' : 'pointer',
                                        opacity: loading ? 0.6 : 1,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Online'}
                                </Button>
                            )}
                        </>
                    ) : (
                        <>
                            {totalAmount > 0 && abstractHomeSetup.c_online_status == 1 && (
                                <Button
                                    onClick={handleSubmitOnline}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        ml: 4,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                        cursor: loading ? 'not-allowed' : 'pointer',
                                        opacity: loading ? 0.6 : 1,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Online'}
                                </Button>
                            )}
                            {totalAmount > 0 && abstractHomeSetup.c_bank_status == 1 && (
                                <Button
                                    onClick={handleSubmitBank}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Bank'}
                                </Button>
                            )}

                            {totalAmount > 0 && abstractHomeSetup.c_cash_status == 1 && (
                                <Button
                                    onClick={handleSubmitCash}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Cash'}
                                </Button>
                            )}

                            {abstractHomeSetup.c_free_status == 1 && (
                                <Button
                                    onClick={handleSubmitFree}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Register'}
                                </Button>
                            )}
                        </>
                    )}
                    {
                        fullDiscountApplied && totalAmount === 0 && (
                            <Button
                                onClick={handleSubmitFree}
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Register'}
                            </Button>
                        )
                    }
                </Box>

                {/* <Box noValidate sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
 
                    {
                        totalAmount > 0 ?
                            abstractHomeSetup.c_online_status == 1 && (
                                <Button
                                    onClick={handleSubmitOnline}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        ml: 4,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                        cursor: loading ? 'not-allowed' : 'pointer', // Disable pointer events when loading
                                        opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                                    }}
                                    disabled={loading} // Disable the button when loading
                                >
                                    {loading ? 'Loading...' : 'Online'}
                                </Button>

                            ) : ""}

                    {
                        totalAmount > 0 ?
                            abstractHomeSetup.c_bank_status == 1 && (
                                <Button
                                    onClick={handleSubmitBank}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Bank'}
                                </Button>
                            ) : ""}

                    {
                        totalAmount > 0 ?
                            abstractHomeSetup.c_cash_status == 1 && (


                                <Button
                                    onClick={handleSubmitCash}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Cash'}
                                </Button>
                            ) : ""}

                    {

                        abstractHomeSetup.c_free_status == 1 && (
                            <Button
                                onClick={handleSubmitFree}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2, backgroundColor: abstractHomeSetup.color_code_two
                                        ? abstractHomeSetup.color_code_two
                                        : gradientBackground,
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Register'}
                            </Button>
                        )}

                </Box> */}

            </div>
        );
    };

    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>

            <Grid container spacing={2}>
                <Box
                    sx={{
                        position: 'relative',
                        //
                        //marginTop: '10px',
                        width: '100%',
                        height: isSmallScreen ? '200px' : '300px',
                        backgroundImage: `url(${(abstractHomeSetup?.conferenceBannerImage) || "https://via.placeholder.com/800x600"})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: isSmallScreen ? 'center' : 'left',
                        padding: isSmallScreen ? '10px' : '20px',
                        color: 'white',
                    }}
                >
                    {/* <Typography variant={isSmallScreen ? 'h6' : 'h2'} component="div">
                        Conference Management System
                    </Typography> */}
                </Box>


                <Grid container justifyContent="center" marginTop="40px">
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        {/* <Typography
                            component="h1"
                            variant="h5"
                            sx={{
                                textAlign: 'center', // Center the text
                            }}>
                            Conference Participant Details
                        </Typography> */}

                        {/* <Grid item xs={12}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid> */}
                        <div>
                            {activeStep === steps.length ? (


                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%',
                                    padding: '16px' // Add some padding on all sides
                                }}>
                                    <Box sx={{
                                        width: '100%',
                                        maxWidth: { xs: '100%', md: '900px', lg: '1200px' }, // Responsive max width
                                        color: '#000000',
                                        marginTop: '5%'
                                    }}>
                                        {error_list && Object.keys(error_list).map(fieldName => (
                                            <div key={fieldName}>
                                                {/* <span style={{ color: 'red' }}>{fieldName}: </span> */}
                                                {error_list[fieldName].map((error, index) => (
                                                    <span key={index} style={{ color: 'red' }}>{error}</span>
                                                ))}
                                            </div>
                                        ))}


                                        <Card sx={{
                                            ...cardStyles,
                                            width: '100%'
                                        }}>
                                            <CardContent >
                                                <Typography component="h1" variant="h5" sx={{
                                                    textAlign: 'center', // Center the text
                                                }}>
                                                    Check Out

                                                </Typography>
                                                <Box component="form" noValidate sx={{ mt: 3 }}>

                                                    {renderSelectedWorkshopInfo()}


                                                </Box>
                                                <Grid container justifyContent="space-between">

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        // onClick={handleNext}
                                                        onClick={handleBack}
                                                        sx={{
                                                            mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                ? abstractHomeSetup.color_code_two
                                                                : gradientBackground,
                                                        }}
                                                    >
                                                        {activeStep === steps.length - 1 ? 'Back' : 'BAck'}
                                                    </Button>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                </div>

                            ) : (
                                <div>
                                    {/* <Typography>{steps[activeStep]}</Typography> */}
                                    {/* Render your form for each step */}
                                    {activeStep === 0 && (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            width: '100%',
                                            margin: '0 auto',
                                            padding: '0 16px' /* optional padding */
                                        }}>

                                            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                                <Grid container spacing={2} alignItems="center">
                                                    {/* Title - takes full width on small screens, 6 columns on large screens */}
                                                    <Grid item xs={12} lg={6}>
                                                        <Typography
                                                            component="h1"
                                                            variant="h5"
                                                            sx={{
                                                                textAlign: { xs: 'center', lg: 'left' }, // Center on mobile, left on desktop
                                                                marginTop: '2%',
                                                            }}
                                                        >
                                                            Conference Participant Details
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} lg={6}>
                                                        <Box sx={{
                                                            display: 'flex',
                                                            justifyContent: { xs: 'center', lg: 'flex-end' }, // Center on mobile, right on desktop
                                                            gap: '10px', // Space between buttons
                                                            mt: { xs: '2%', lg: '0' } // Margin top only on mobile
                                                        }}>
                                                            <Button
                                                                sx={{
                                                                    ":hover": { color: "white" },
                                                                    backgroundColor: abstractHomeSetup.color_code_two
                                                                        ? abstractHomeSetup.color_code_two
                                                                        : gradientBackground,
                                                                }}
                                                                color='success'
                                                                size='small'
                                                                variant='contained'
                                                                component={Link}
                                                                to="/conference/particpant-verification"
                                                            >
                                                                Back To Verification
                                                            </Button>
                                                        </Box>
                                                    </Grid>

                                                </Grid>
                                                <Card sx={cardStyles}  >
                                                    <CardContent >

                                                        <Box component="form" noValidate sx={{ mt: 3 }}>
                                                            <Grid container spacing={4}>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Title</InputLabel>
                                                                        <Select
                                                                            value={nameTitle}
                                                                            onChange={handleNameTitle}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Action"
                                                                        >
                                                                            <MenuItem value={'Mr'}>Mr</MenuItem>
                                                                            <MenuItem value={'Mrs'}>Mrs</MenuItem>
                                                                            <MenuItem value={'Ms'}>Ms</MenuItem>
                                                                            <MenuItem value={'Dr'}>Dr</MenuItem>
                                                                            <MenuItem value={'Prof'}>Prof</MenuItem>
                                                                            <MenuItem value={'Eng'}>Eng</MenuItem>
                                                                            <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                                                                        </Select>
                                                                        <FormHelperText>{addWorkShopParticpant?.error_list?.name_title}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>


                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth
                                                                        label="Full Name"
                                                                        autoFocus
                                                                        name='participant_name' onChange={handleInput}
                                                                        value={editConferenceParticpant?.participant_name || ""}
                                                                        helperText={addWorkShopParticpant?.error_list?.participant_name} />
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        label="Saudi Council No"
                                                                        type="text"
                                                                        name='participant_saudi_council_no'
                                                                        onChange={handleInput}
                                                                        value={editConferenceParticpant?.participant_saudi_council_no || ""}
                                                                        helperText={editConferenceParticpant?.error_list?.participant_saudi_council_no || ""}
                                                                    />
                                                                    <span style={{ color: 'red', textAlign: 'center' }}>
                                                                        If you don't have, just type 0000
                                                                    </span>
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Conference Category</InputLabel>
                                                                        <Select

                                                                            value={editConferenceParticpant?.conference_category_id || ""}
                                                                            // onChange={handleWorkShopCategory}
                                                                            onChange={handleregistration}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Conference Category" >
                                                                            {
                                                                                conferenceCategoryData && conferenceCategoryData?.map((val, index) => {
                                                                                    return (
                                                                                        <MenuItem value={val.id} key={val.id}>{val.conference_category_title} </MenuItem>
                                                                                    )
                                                                                })
                                                                            }



                                                                        </Select>

                                                                        <FormHelperText>{addWorkShopParticpant?.error_list?.participant_workshop_categoy}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                {/* <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        id="email"
                                                                        label="Email Address"
                                                                        autoComplete="participant_email"
                                                                        name='participant_email'
                                                                        onChange={handleInput}
                                                                        value={editConferenceParticpant?.participant_email || ""}
                                                                        helperText={editConferenceParticpant?.error_list?.participant_email || ""}
                                                                        
                                                                    />
                                                                    
                                                                </Grid> */}
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        id="email"
                                                                        label="Email Address"
                                                                        autoComplete="participant_email"
                                                                        name="participant_email"
                                                                        onChange={handleInput}
                                                                        value={editConferenceParticpant?.participant_email || ""}
                                                                        error={Boolean(error_list?.participant_email)}   // 🔴 shows red underline if error exists
                                                                        helperText={error_list?.participant_email ? error_list.participant_email[0] : ""} // ✅ show error inside helperText
                                                                    />
                                                                </Grid>


                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        label="Contact Number"
                                                                        type="text"
                                                                        name='participant_phone_number'
                                                                        onChange={handleInput}
                                                                        value={editConferenceParticpant?.participant_phone_number || ""}
                                                                        helperText={editConferenceParticpant?.error_list?.participant_phone_number || ""}
                                                                    />
                                                                    {/* <span style={{ color: 'red', textAlign: 'center' }}>
                                                                If you don't have, just type 0000
                                                            </span> */}
                                                                </Grid>



                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth

                                                                        label="Profession"
                                                                        autoFocus
                                                                        name='participant_profession'
                                                                        onChange={handleInput} value={editConferenceParticpant?.participant_profession || ""}
                                                                        helperText={editConferenceParticpant?.error_list?.participant_profession} />
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl>
                                                                        <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                                                                        <RadioGroup
                                                                            row
                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                            name="row-radio-buttons-group"
                                                                            value={gender.toString()}  // Convert the numeric value to a string
                                                                            onChange={handleChange}
                                                                        >
                                                                            <FormControlLabel value="0" control={<Radio />} label="Male" />
                                                                            <FormControlLabel value="1" control={<Radio />} label="Female" />
                                                                        </RadioGroup>
                                                                        <FormHelperText>{addWorkShopParticpant?.error_list?.participant_gender}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>


                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Country</InputLabel>
                                                                        <Select
                                                                            value={country || ""}
                                                                            onChange={handleCountry}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Action" >
                                                                            <MenuItem value={'Saudi Arabia'}>Saudi Arabia</MenuItem>
                                                                            <MenuItem value={'UAE'}>UAE</MenuItem>
                                                                            <MenuItem value={'Qatar'}> Qatar</MenuItem>
                                                                            <MenuItem value={'Oman'}>Oman </MenuItem>
                                                                            <MenuItem value={'Jordan'}>Jordan</MenuItem>
                                                                            <MenuItem value={'Trurky'}>Trurky </MenuItem>

                                                                        </Select>
                                                                        <FormHelperText></FormHelperText>
                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12} >
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth
                                                                        label="City"
                                                                        autoFocus
                                                                        name='participant_city' onChange={handleInput} value={editConferenceParticpant?.participant_city || ""} />
                                                                </Grid>
                                                            </Grid>

                                                            {singleConferenceCategory && (
                                                                <>
                                                                    <br></br>
                                                                    <Card sx={{ width: '100%', float: 'center' }} >
                                                                        <CardContent >
                                                                            <Typography component="h1" variant="h5" sx={{
                                                                                textAlign: 'center', // Center the text
                                                                            }}>
                                                                                Registration Fees
                                                                            </Typography>
                                                                            <br></br>
                                                                            <Typography
                                                                                component="h6"
                                                                                variant="h5"
                                                                                sx={{
                                                                                    textAlign: 'center', // Center the text
                                                                                    color: 'red', // Set the text color to red
                                                                                }} >
                                                                                {addWorkShopParticpant?.error_list?.selectedConferenceAmounts}
                                                                            </Typography>


                                                                            <Box component="form" noValidate sx={{ mt: 3 }}>
                                                                                <Grid container spacing={4}>

                                                                                    <Grid item xs={6} >

                                                                                    </Grid>

                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <FormControlLabel
                                                                                        control={<Checkbox color="success" checked={singleConferenceCategory?.conference_category_title !== null} />}
                                                                                        label={
                                                                                            <span
                                                                                                sx={{
                                                                                                    margin: '55px',
                                                                                                    display: 'inline-block',
                                                                                                }}
                                                                                            >
                                                                                                {singleConferenceCategory?.workshop_category_title}
                                                                                            </span>
                                                                                        }
                                                                                        color="success"
                                                                                        name="permissions"
                                                                                    />

                                                                                    <TableContainer component={Paper}>
                                                                                        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                                                                            <FormControl sx={{ minWidth: 120 }}>
                                                                                                <InputLabel>Currency</InputLabel>
                                                                                                <Select
                                                                                                    value={selectedCurrency}
                                                                                                    label="Currency"
                                                                                                    //onChange={(e) => setSelectedCurrency(e.target.value)}
                                                                                                    onChange={handleCurrencyChange}
                                                                                                    disabled={editConferenceParticpant?.event_affiliate_status ? true : false} // Disable if event_affiliate_status is true
                                                                                                >
                                                                                                    {currencyOptions.map((option) => (
                                                                                                        <MenuItem key={option.value} value={option.value}>
                                                                                                            {option.label}
                                                                                                        </MenuItem>
                                                                                                    ))}
                                                                                                </Select>
                                                                                            </FormControl>
                                                                                        </Box>
                                                                                        <Table>
                                                                                            <TableHead>
                                                                                                {
                                                                                                    isMobile ? (
                                                                                                        <>
                                                                                                            <TableCell colSpan={5} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                                                                                Conference Informations
                                                                                                            </TableCell>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <TableRow>
                                                                                                                <TableCell>ID</TableCell>
                                                                                                                <TableCell>Conference Name</TableCell>
                                                                                                                <TableCell>Conference Day</TableCell>
                                                                                                                <TableCell>Conference Date</TableCell>
                                                                                                                <TableCell>Conference End Date</TableCell>
                                                                                                                <TableCell>Conference Start Time</TableCell>
                                                                                                                <TableCell>Conference End Time</TableCell>
                                                                                                                <TableCell>Price ({selectedCurrency})</TableCell>
                                                                                                                <TableCell>Select</TableCell>
                                                                                                            </TableRow>
                                                                                                        </>
                                                                                                    )
                                                                                                }
                                                                                            </TableHead>
                                                                                            <TableBody>

                                                                                                {singleConferenceCategory.conferences &&
                                                                                                    singleConferenceCategory.conferences.map((row, i) => {
                                                                                                        const { isDisabled, color } = isCheckboxDisabled(row);

                                                                                                        const paidWorkshops = updateConferenceParticpantConferences.some((alreadySelected) => {
                                                                                                            const isMatch =
                                                                                                                alreadySelected.conference_id === row.id &&
                                                                                                                alreadySelected.conference_day === row.conference_day &&
                                                                                                                alreadySelected.payment_status === 1;

                                                                                                            //console.log("Checking match for:", alreadySelected, "Row:", row, "Is Match:", isMatch);
                                                                                                            return isMatch;
                                                                                                        });


                                                                                                        const notPaidWorkshops = updateConferenceParticpantConferences && updateConferenceParticpantConferences.filter(workshop =>
                                                                                                            workshop.conference_id === false && workshop.payment_status === 0

                                                                                                        );
                                                                                                        return (



                                                                                                            <TableRow
                                                                                                                key={row.id}
                                                                                                                style={{
                                                                                                                    backgroundColor: isCheckboxDisabled(row).color,
                                                                                                                    color: isCheckboxDisabled(row).color ? 'white' : 'inherit',
                                                                                                                    ...(paidWorkshops && { backgroundColor: '#4caf50', color: 'white !important' })

                                                                                                                }}

                                                                                                            >
                                                                                                                {
                                                                                                                    isMobile ? (
                                                                                                                        <>
                                                                                                                            <TableCell style={{ display: 'flex', flexWrap: 'wrap', flexBasis: '100%', paddingLeft: '20px' }}>



                                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px', color: paidWorkshops ? 'white' : 'inherit', color: isCheckboxDisabled(row).color ? 'rgba(255, 255, 255, 0.7)' : 'inherit', }} >
                                                                                                                                    <strong>Conference Name:</strong> {row.conference_name}
                                                                                                                                    <TableCell style={{ display: 'flex', flexWrap: 'wrap', flexBasis: '100%', paddingLeft: '20px', color: paidWorkshops ? 'white' : 'inherit' }}>


                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>No: {i + 1} </strong>
                                                                                                                                            <hr></hr>
                                                                                                                                        </Box>
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Conference Name:</strong> {row.conference_name}
                                                                                                                                        </Box>
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Conference Day:</strong> {row.conference_day}
                                                                                                                                        </Box>
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Conference Date:</strong> {row.conference_date}
                                                                                                                                        </Box>
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Conference End Date:</strong> {row.conference_end_date}
                                                                                                                                        </Box>
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Conference Start Time:</strong> {row.conference_start_time}
                                                                                                                                        </Box>
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Conference End Time:</strong> {row.conference_end_time}
                                                                                                                                        </Box>

                                                                                                                                        {/* {
                                                                                                                                            editConferenceParticpant.event_affiliate_status === 1 ? (
                                                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                                    <strong>Conference Price ({selectedCurrency}):</strong>{' '}
                                                                                                                                                    <span style={{ textDecoration: 'line-through', marginRight: '8px', color: 'gray' }}>
                                                                                                                                                        {row.conference_amount}
                                                                                                                                                    </span>
                                                                                                                                                    
                                                                                                                                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                                                                                                                                        {row.conference_discount_amount}
                                                                                                                                                    </span>
                                                                                                                                                </Box>
                                                                                                                                            ) : (
                                                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                                    <strong>Conference Price:</strong> {row.conference_amount}
                                                                                                                                                </Box>
                                                                                                                                            )
                                                                                                                                        } */}
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Price ({selectedCurrency}):</strong>
                                                                                                                                            {editConferenceParticpant.event_affiliate_status === 1 ? (
                                                                                                                                                <>
                                                                                                                                                    <span style={{ textDecoration: 'line-through', marginRight: '8px', color: 'gray' }}>
                                                                                                                                                        {getPriceByCurrency(row, selectedCurrency)}
                                                                                                                                                    </span>
                                                                                                                                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                                                                                                                                        {row.conference_discount_amount}
                                                                                                                                                    </span>
                                                                                                                                                </>
                                                                                                                                            ) : (
                                                                                                                                                getPriceByCurrency(row, selectedCurrency)
                                                                                                                                            )}
                                                                                                                                        </Box>
                                                                                                                                        <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                                            <strong>Select :</strong>
                                                                                                                                            {
                                                                                                                                                paidWorkshops ? (
                                                                                                                                                    <Checkbox
                                                                                                                                                        {...label}
                                                                                                                                                        disabled
                                                                                                                                                        sx={{
                                                                                                                                                            color: pink[800],
                                                                                                                                                            '&.Mui-checked': {
                                                                                                                                                                color: pink[600],
                                                                                                                                                            },
                                                                                                                                                        }}
                                                                                                                                                    />
                                                                                                                                                ) : (
                                                                                                                                                    notPaidWorkshops.some(workshop => workshop.conference_day === row.conference_day) ? (

                                                                                                                                                        <Checkbox
                                                                                                                                                            checked={editConferenceParticpantConferences.some((selectedConference) => selectedConference.conference_id === row.id)}
                                                                                                                                                            // onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                                                                            onChange={(e) => handleCheckboxChange(e, row, editConferenceParticpant.event_affiliate_status === 1 ? row.conference_discount_amount : row.conference_amount)}
                                                                                                                                                            //disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                                            //style={{ color: 'black', backgroundColor: 'yellow' }}
                                                                                                                                                            sx={{
                                                                                                                                                                mt: 1,
                                                                                                                                                                color: abstractHomeSetup.color_code_two
                                                                                                                                                                    ? abstractHomeSetup.color_code_two
                                                                                                                                                                    : gradientBackground,
                                                                                                                                                                fontWeight: 'bold',
                                                                                                                                                                transform: 'scale(2)', // Makes the checkbox larger
                                                                                                                                                                '&.Mui-checked': {
                                                                                                                                                                    color: abstractHomeSetup.color_code_two
                                                                                                                                                                        ? abstractHomeSetup.color_code_two
                                                                                                                                                                        : gradientBackground,
                                                                                                                                                                },
                                                                                                                                                            }} />
                                                                                                                                                    ) : (<>
                                                                                                                                                        <Checkbox
                                                                                                                                                            sx={{
                                                                                                                                                                color: isCheckboxDisabled(row).color ? 'white' : 'inherit',
                                                                                                                                                                '&.Mui-checked': {
                                                                                                                                                                    color: isCheckboxDisabled(row).color ? 'white' : 'inherit', // Ensure checked state inherits the dynamic color
                                                                                                                                                                },
                                                                                                                                                                '&.Mui-disabled': {
                                                                                                                                                                    color: isCheckboxDisabled(row).color ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)', // Adjust disabled color
                                                                                                                                                                },
                                                                                                                                                            }}
                                                                                                                                                            checked={editConferenceParticpantConferences.some(
                                                                                                                                                                (selectedConference) => selectedConference.conference_id === row.id
                                                                                                                                                            )}
                                                                                                                                                            //onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                                                                            onChange={(e) => handleCheckboxChange(e, row, editConferenceParticpant.event_affiliate_status === 1 ? row.conference_discount_amount : row.conference_amount)}
                                                                                                                                                            disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                                        /> </>
                                                                                                                                                        // <Checkbox 
                                                                                                                                                        //     checked={editConferenceParticpantConferences.some((selectedConference) => selectedConference.conference_id === row.id)}
                                                                                                                                                        //     onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                                                                        //     disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                                        // />
                                                                                                                                                    )


                                                                                                                                                )


                                                                                                                                            }

                                                                                                                                            {isCheckboxDisabled(row).seatLimitMessage && (
                                                                                                                                                <span style={{ color: 'red' }}>
                                                                                                                                                    {isCheckboxDisabled(row).seatLimitMessage}
                                                                                                                                                </span>
                                                                                                                                            )}

                                                                                                                                            {isCheckboxDisabled(row).timeOffMessage && (
                                                                                                                                                <span style={{ color: 'orange' }}>
                                                                                                                                                    {isCheckboxDisabled(row).timeOffMessage}
                                                                                                                                                </span>
                                                                                                                                            )}
                                                                                                                                        </Box>
                                                                                                                                    </TableCell>

                                                                                                                                </Box>
                                                                                                                            </TableCell>
                                                                                                                        </>
                                                                                                                    ) : (
                                                                                                                        <>

                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit', }}>{i + 1}</TableCell>
                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>{row.conference_name}</TableCell>
                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>{row.conference_day}</TableCell>
                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>{row.conference_date}</TableCell>
                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>{row.conference_end_date}</TableCell>
                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>{row.conference_start_time}</TableCell>
                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>{row.conference_end_time}</TableCell>
                                                                                                                            {/* <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>{row.conference_amount}</TableCell> */}
                                                                                                                            {/* <TableCell>
                                                                                                                                {editConferenceParticpant.event_affiliate_status === 1 ? (
                                                                                                                                    <>
                                                                                                                                        <span style={{ textDecoration: 'line-through', marginRight: '5px' }}>
                                                                                                                                            {row.conference_amount} 
                                                                                                                                        </span>
                                                                                                                                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                                                                            {row.conference_discount_amount} 
                                                                                                                                        </span>
                                                                                                                                    </>
                                                                                                                                ) : (
                                                                                                                                    row.conference_amount
                                                                                                                                )}
                                                                                                                            </TableCell> */}
                                                                                                                            <TableCell>
                                                                                                                                {editConferenceParticpant.event_affiliate_status === 1 ? (
                                                                                                                                    <>
                                                                                                                                        <span style={{ textDecoration: 'line-through', marginRight: '5px' }}>
                                                                                                                                            {getPriceByCurrency(row, selectedCurrency)}
                                                                                                                                        </span>
                                                                                                                                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                                                                            {row.conference_discount_amount}
                                                                                                                                        </span>
                                                                                                                                    </>
                                                                                                                                ) : (
                                                                                                                                    getPriceByCurrency(row, selectedCurrency)
                                                                                                                                )}
                                                                                                                            </TableCell>

                                                                                                                            <TableCell style={{ color: paidWorkshops ? 'white' : 'inherit' }}>
                                                                                                                                {
                                                                                                                                    paidWorkshops ? (
                                                                                                                                        <Checkbox
                                                                                                                                            {...label}
                                                                                                                                            disabled
                                                                                                                                            sx={{
                                                                                                                                                color: pink[800],
                                                                                                                                                '&.Mui-checked': {
                                                                                                                                                    color: pink[600],
                                                                                                                                                },
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    ) : (
                                                                                                                                        notPaidWorkshops.some(workshop => workshop.conference_day === row.conference_day) ? (

                                                                                                                                            <Checkbox
                                                                                                                                                checked={editConferenceParticpantConferences.some((selectedConference) => selectedConference.conference_id === row.id)}
                                                                                                                                                // onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                                                                //onChange={(e) => handleCheckboxChange(e, row, editConferenceParticpant.event_affiliate_status === 1 ? row.conference_discount_amount : row.conference_amount)}
                                                                                                                                                onChange={(e) => handleCheckboxChange(e, row, editConferenceParticpant.event_affiliate_status ? row.conference_discount_amount : getPriceByCurrency(row, selectedCurrency))}
                                                                                                                                                //disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                                //style={{ color: 'black', backgroundColor: 'yellow' }}
                                                                                                                                                sx={{
                                                                                                                                                    color: abstractHomeSetup.color_code_two
                                                                                                                                                        ? abstractHomeSetup.color_code_two
                                                                                                                                                        : gradientBackground,
                                                                                                                                                    fontWeight: 'bold',
                                                                                                                                                    transform: 'scale(1)', // Makes the checkbox larger
                                                                                                                                                    '&.Mui-checked': {
                                                                                                                                                        color: abstractHomeSetup.color_code_two
                                                                                                                                                            ? abstractHomeSetup.color_code_two
                                                                                                                                                            : gradientBackground,
                                                                                                                                                    },
                                                                                                                                                }}
                                                                                                                                            />
                                                                                                                                        ) : (
                                                                                                                                            // <Checkbox
                                                                                                                                            //     checked={editConferenceParticpantConferences.some((selectedConference) => selectedConference.conference_id === row.id)}
                                                                                                                                            //     onChange={(e) => handleCheckboxChange(e, row, row.conference_amount)}
                                                                                                                                            //     disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                            // />
                                                                                                                                            <Checkbox
                                                                                                                                                sx={{
                                                                                                                                                    color: isCheckboxDisabled(row).color ? 'white' : 'inherit',
                                                                                                                                                    '&.Mui-checked': {
                                                                                                                                                        color: isCheckboxDisabled(row).color ? 'white' : 'inherit', // Ensure checked state inherits the dynamic color
                                                                                                                                                    },
                                                                                                                                                    '&.Mui-disabled': {
                                                                                                                                                        color: isCheckboxDisabled(row).color ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)', // Adjust disabled color
                                                                                                                                                    },
                                                                                                                                                }}
                                                                                                                                                checked={editConferenceParticpantConferences.some(
                                                                                                                                                    (selectedConference) => selectedConference.conference_id === row.id
                                                                                                                                                )}
                                                                                                                                                //onChange={(e) => handleCheckboxChange(e, row, editConferenceParticpant.event_affiliate_status === 1 ? row.conference_discount_amount : row.conference_amount)}
                                                                                                                                                onChange={(e) => handleCheckboxChange(e, row, editConferenceParticpant.event_affiliate_status ? row.conference_discount_amount : getPriceByCurrency(row, selectedCurrency))}
                                                                                                                                                disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                                                            />
                                                                                                                                        )


                                                                                                                                    )


                                                                                                                                }
                                                                                                                                <br></br>
                                                                                                                                <br></br>
                                                                                                                                {isCheckboxDisabled(row).seatLimitMessage && (
                                                                                                                                    <span style={{ color: 'red' }}>
                                                                                                                                        {isCheckboxDisabled(row).seatLimitMessage}
                                                                                                                                    </span>
                                                                                                                                )}

                                                                                                                                {isCheckboxDisabled(row).timeOffMessage && (
                                                                                                                                    <span style={{ color: 'orange' }}>
                                                                                                                                        {isCheckboxDisabled(row).timeOffMessage}
                                                                                                                                    </span>
                                                                                                                                )}

                                                                                                                            </TableCell>
                                                                                                                        </>
                                                                                                                    )
                                                                                                                }





                                                                                                            </TableRow>
                                                                                                        );
                                                                                                    })}
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    </TableContainer>
                                                                                </Grid>
                                                                                <Grid container justifyContent="space-between">
                                                                                    <Button

                                                                                        disabled={activeStep === 0}
                                                                                        onClick={handleBack}
                                                                                        sx={{ mt: 5 }}>
                                                                                        Back
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="primary"
                                                                                        onClick={handleNext}
                                                                                        sx={{
                                                                                            mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                                                ? abstractHomeSetup.color_code_two
                                                                                                : gradientBackground,
                                                                                        }}
                                                                                    >
                                                                                        {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                                                    </Button>
                                                                                </Grid>

                                                                            </Box>
                                                                        </CardContent>
                                                                    </Card>
                                                                </>)}


                                                            {/* <Grid container justifyContent="space-between">
                                                                <Button
                                                                    disabled={activeStep === 0}
                                                                    onClick={handleBack}
                                                                    sx={{ mt: 5 }}>
                                                                    Back
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                                </Button>
                                                            </Grid> */}

                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        </div>

                                    )}



                                </div>
                            )}
                        </div>
                    </Grid>
                </Grid>






            </Grid>

            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    );
}

export default UpdateConfereceParticipant;
